export default "__VITE_ASSET__f684f27e__"